export * from "./active";
export * from "./countries";
export * from "./segments";
export * from "./dates";
export * from "./day";
export * from "./game";
export * from "./layers";
export * from "./wrestlers";
export * from "./groups";
export * from "./tiers";
export * from "./dialog";
export * from "./spacing";
export * from "./palette";
export * from "./venues";
var ac = "'Archivo', sans-serif";
var ab = "'Archivo Black', sans-serif";
var ic = '"Inclusive Sans", sans-serif';
export var fontFamilies = {
    primaryFont: ab,
    secondaryFont: ic,
    bodyFont: ac,
    buttonFont: ic
};
export var defaultSegmentDuration = 60 * 3;
export var BORDERRADIUS = "6px";
export var DURATIONTIMEOUT = 500;
